import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    greenDot: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
      margin: '0px 12px 4px 12px',
    },
    locationStyle: {
      color: 'rgba(255, 255, 255, .38)',
    },
    outerCard: {
      padding: 8,
    },
    innerCard: {
      padding: 16,
    },
    pointer: {
      cursor: 'pointer',
    },
    assignGrid: {
      paddingRight: 36,
      '& > div > button': {
        alignSelf: 'center',
        width: 'fit-content',
        height: '32px',
      },
    },
    messageGrid: {
      padding: '16px',
    },
    emptyBox: {
      verticalAlign: 'middle',
      marginRight: '18px',
    },
    divText: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    unAssignedContainer: {
      '& .cardWithColor': {
        backgroundColor: 'rgba(42, 171, 63, 0.12)',
      },
    },
  }),
);

export default useStyles;
